/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *   Amina Rais - Massive Improvements
 *
 * Version: 1
 *
 *******************************************************************************/

import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { withStyles } from '@mui/styles';
import PageHeader from './PageHeader';
import PageFooter from './PageFooter';
import { compose } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../store/actions';
import { useNavigate } from 'react-router-dom';
import CookieConsent, { Cookies } from "react-cookie-consent";

const styles = theme => ({
  layout: {
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.grayed
  },
  main: {
    flex: 1,
    marginBottom: '10px'
  },
  gridInner: {
    maxWidth: '100%',
  },
  maxWidthDiv: {
    width: '100%'
  }

});

const Layout = ({ initializeApp, ...props }) => {
  const navigate = useNavigate()
  useLayoutEffect(() => {
    let redirectUrl = initializeApp();

    if (typeof redirectUrl === 'string' || redirectUrl instanceof String) {
      setTimeout(() => {
        navigate(redirectUrl)
      })
    }
  }, [])

  const { classes, children } = props;

  return (
    <>

      <div className={classes.layout}>
        <PageHeader />
        <main className={classes.main}>
          <Grid container justify="center">
            <Grid container className={classes.gridInner}>
              <Grid item sm={12} xs={12} md={12} className={classes.maxWidthDiv} >
                {children}
              </Grid>
            </Grid>
          </Grid>
        </main>

        <PageFooter />
      </div>

      <CookieConsent
        location="bottom"
        buttonText="Accept"
        cookieName="myAwesomeCookieName2"
        style={{ background: "#2c2d2e" }}
        buttonStyle={{ background: "#d0b0ff", color: "black", fontSize: "13px" }}
        expires={150}
      >
        By continuing to browse or by clicking 'Accept', you agree to the storing of cookies on your device to enhance your site experience and for analytical purposes.{" "}

      </CookieConsent>


    </>
  );
}


Layout.propTypes = {
  classes: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  initialized: state.app.initialized,
  loginned: state.loginned,
  userId: state.user.userid
});

const mapDispatchToProps = {
  initializeApp: actions.app.initializeApp
};

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Layout);
